// src/hooks/useEleve.js
import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useEleveWitouthGroup = (etablissementId, classeDetails, matiere, enabled = true, groupeId = null) => {
    // Construire dynamiquement l'URL avec les paramètres pour la requête des élèves sans groupe
    const params = new URLSearchParams();
    params.append('etablissement_id', etablissementId);

    // Ajouter chaque classe dans les paramètres
    classeDetails.forEach(classe => params.append('classe_details', classe));

    // Matière : exclut les élèves déjà dans un groupe de CETTE matière (un élève
    // peut être dans un groupe maths ET un groupe français — cf. modèle Groupe).
    if (matiere) params.append('matiere', matiere);

    // Groupe dont on compose la liste (2026-09-30). Pour un DEMI-GROUPE (une
    // seule classe), le back propose alors les élèves de sa classe qui n'y sont
    // pas encore, barrettes comprises : le prof compose lui-même sa moitié de
    // classe. Pour un groupe de besoin, le back l'ignore (règle ci-dessus).
    if (groupeId) params.append('groupe_id', groupeId);

    const urlfetch = `${url}groupes/eleves-sans-groupe/?${params.toString()}`;

    // Utiliser le hook `useApi` avec l'URL construite et les autres paramètres
    return useApi(urlfetch, [], null, enabled);
};